export default __webpack_public_path__ + "static/1-72979f049e20eb46bb5e2c27d6f1536e.jpeg";